var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"align-content":"center"}},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"alt":"Image"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }